import { AuthContext } from 'context/AuthContext';
import React, { useContext, useEffect } from 'react';
import { HeaderFilterService } from 'services/main';
import { useLocation } from 'react-router-dom';
import { useCookies } from 'react-cookie';
import { parseJwt } from 'utils/parse';
const Amplifique = () => {
  const location = useLocation();
  const pathname = location.pathname;
  const { authContext } = useContext(AuthContext);
  const { user } = authContext;
  const email = `${user.id}@userleankeep.com`;
  const [cookie] = useCookies();

  useEffect(() => {
    if (pathname === '/login' || pathname === '/logout' || !cookie?.authToken || pathname.startsWith('/chamado-woba')) {
      return null;
    }
    const styleTag = document.createElement('style');
    styleTag.innerHTML = `
      .amp-icon-cancel:before {
        display: block !important;
      }
    `;
    document.head.appendChild(styleTag);

    const loadScript = () => {
      return new Promise((resolve, reject) => {
        if (document.querySelector('script[src="https://cdn.amplifique.me/amplifiqueme-inapp-survey.js"]')) {
          resolve();
          return;
        }

        const script = document.createElement('script');
        script.src = 'https://cdn.amplifique.me/amplifiqueme-inapp-survey.js';
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
      });
    };

    const initSurvey = async () => {
      try {
        const companyResponse = await HeaderFilterService.company(cookie?.companies?.id, cookie?.authToken);
        const companyType = companyResponse.data.tipoNome;

        const { utyp } = parseJwt(cookie.authToken);
        const { isSuper, isAdmin, isOperationalUser, isCommonUser } = {
          isSuper: parseInt(utyp) === 1,
          isAdmin: parseInt(utyp) === 2,
          isOperationalUser: parseInt(utyp) === 3,
          isCommonUser: parseInt(utyp) === 4,
        };
        const userType = isSuper
          ? 'Super-Usuário'
          : isAdmin
          ? 'Administrador'
          : isOperationalUser
          ? 'Operacional'
          : isCommonUser
          ? 'Chamado'
          : 'Desconecido';

        await loadScript();

        window.Amplifiqueme = window.Amplifiqueme || {};
        window.Amplifiqueme.onLoad = () => {
          window.Amplifiqueme.identify(
            {
              email: email,
              created_at: user?.signUpUnixDate,
              name: user?.fullName,
              company: cookie?.companies?.name,
              custom_fields: {
                nome_empresa: cookie?.companies?.name,
                nome_usuario: user?.fullName,
                tipo_usuario: userType,
                segmento: companyType,
                idUsuario: user?.id,
                ehAdmin: user?.type === 'Operacional' ? 'True' : 'False',
                idEmpresa: String(cookie?.companies?.id),
                plataforma: 'Web-Novo',
                nomeEmpresa: cookie?.companies?.name,
                os: 'WEB',
              },
            },
            true,
          );
        };

        const existingSurveyElement = document.querySelector('ampl-survey');
        if (!existingSurveyElement) {
          const amplSurveyElement = document.createElement('ampl-survey');
          amplSurveyElement.setAttribute('identifier', '64286cc685cacdbcf60441ac');
          //amplSurveyElement.setAttribute('force', 'true');
          //amplSurveyElement.setAttribute('debug', 'true');
          document.body.appendChild(amplSurveyElement);
        }
      } catch (error) {
        console.error('Error initializing Amplifique survey:', error);
      }
    };
    if (cookie?.companies?.id && user) {
      initSurvey();
    }

    return () => {
      const existingSurveyElement = document.querySelector('ampl-survey');
      if (existingSurveyElement && existingSurveyElement.parentNode) {
        existingSurveyElement.parentNode.removeChild(existingSurveyElement);
      }

      if (styleTag && styleTag.parentNode) {
        styleTag.parentNode.removeChild(styleTag);
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user?.id, cookie?.authToken, pathname, cookie?.companies?.id]);

  return <div></div>;
};

export default Amplifique;
